import { render, staticRenderFns } from "./Fornecedores.vue?vue&type=template&id=2dd43ddd&scoped=true&"
import script from "./fornecedores.js?vue&type=script&lang=js&"
export * from "./fornecedores.js?vue&type=script&lang=js&"
import style0 from "./Fornecedores.vue?vue&type=style&index=0&id=2dd43ddd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd43ddd",
  null
  
)

export default component.exports